var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBeet = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C15.3 9 17 11.2 17 14C17 16.8 14.8 19 12 19C9.2 19 7 16.8 7 14C7 11.2 8.7 9 12 9Z",
    fill: "#8E2447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.8C12 18.8 12.6 20.5 12.4 22C12.3 22.6 11.7 22.6 11.6 22C11.4 20.5 12 18.8 12 18.8Z",
    fill: "#6D1B36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11C9.5 11 8.6 12.2 8.6 14",
    stroke: "#A83A5A",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C12 9 8.5 7.5 8 5",
    stroke: "#2E7D32",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V3",
    stroke: "#2E7D32",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C12 9 15.5 7.5 16 5",
    stroke: "#2E7D32",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C7 3.4 5.5 3 5.5 3C5.5 3 6 5.2 8 5Z",
    fill: "#43A047"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12 1.5 12.8 0.8 12.8 0.8C12.8 0.8 13.6 2.4 12 3Z",
    fill: "#43A047"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5C17 3.4 18.5 3 18.5 3C18.5 3 18 5.2 16 5Z",
    fill: "#43A047"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12 1.5 11.2 0.8 11.2 0.8C11.2 0.8 10.4 2.4 12 3Z",
    fill: "#4CAF50"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBeet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beet.6657586d63bce21727185f801da75e9c.svg";